import axios from "axios";
import { useState, useEffect, useRef } from "react";
import {
  DASHBOARD,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
} from "../../routes/routes";
import { Link } from "react-router-dom";
import Select from "react-select";
import { NoDataFound, NoUserFound, hasRole } from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Glasschap from "../../assets/images/chapter.png";
import Glassusers from "../../assets/images/users.png";
import Contribution from "../../assets/images/contribution.png";
import Region from "../../assets/images/region.png";
import Country from "../../assets/images/region.png";
import State from "../../assets/images/region.png";
import Events from "../../assets/images/events.png";
import One2one from "../../assets/images/one2one.png";
import Referals from "../../assets/images/referals.png";
import Admin from "../../assets/images/admin.png";
import Guest from "../../assets/images/guest.png";
import Powerdate from "../../assets/images/powerdate.png";
import Inductions from "../../assets/images/guest.png";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import Loader, { OvalLoader } from "../../components/common/Loader"; // Import the loader component
// import profileImg1 from "../../assets/images/profile1.jpg";
// import One2oneRed from "../../assets/images/onetoone-red.png";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import Smile from "../../assets/images/smile.png";
import calendarWhite from "../../assets/images/calendar-white.png";
import OnetoOneWhite from "../../assets/images/onetoone-white.png";
import RflWhite from "../../assets/images/rfl-white.png";
import VisitorsWhite from "../../assets/images/visitors-white.png";
import chiefGuestWhite from "../../assets/images/cheif-guest-white.png";
import user1 from "../../assets/images/user-1.jpg";
import { toast } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import { Navigation } from "swiper/modules";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const Dashboard = () => {
  const { hasPermission } = usePermission();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ovalLoading, setOvalLoading] = useState(true);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState([]);
  const [chapterOptions, setChapterOptions] = useState([]);
  const [filter, setFilter] = useState([]);
  const [showClearBtn, setShowClearBtn] = useState(false);
  const refFlatpickr = useRef(null);
  const [pdfLoading, setPdfLoading] = useState(false);

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const handleDownloadPDF = async (reportType) => {
    try {
      setPdfLoading(true);
      // Create a new PDF document
      const currentDate = moment().format("DD-MM-YYYY");
      const doc = new jsPDF();
      var headers = [];
      var pdfData = [];
      var fileName = "";
      var pdfTitle = "";

      headers = ["Sl.No."];
      if (hasRole([1])) {
        headers.push("Country");
      }
      if (hasRole([1, 6])) {
        headers.push("State");
      }
      if (hasRole([1, 6, 7])) {
        headers.push("Region");
      }
      if (hasRole([1, 6, 7, 2])) {
        headers.push("Chapter");
      }
      headers.push("Member");

      if (reportType === "top_10_points_members") {
        // Define table headers and data
        headers.push("Points");
        pdfData = data.top10PointsUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.points);
          return pData;
        });
        fileName = `Top10Points_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Points`;
      } else if (reportType === "top_10_business_given_members") {
        // Define table headers and data
        headers.push("Business Value");
        pdfData = data.top10BusinessUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(
            parseFloat(data.business_value_without_format).toLocaleString(
              "en-IN",
            ),
          );
          return pData;
        });
        fileName = `Top10Business_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Business Value`;
      } else if (reportType === "top_10_referral_given_members") {
        // Define table headers and data
        headers.push("RFLs Count");
        pdfData = data.top10ReferralsGivenUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.referrals_count);
          return pData;
        });
        fileName = `Top10Referrals_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Referrals Given Count`;
      } else if (reportType === "top_10_visitors_members") {
        // Define table headers and data
        headers.push("Visitors Count");
        pdfData = data.top10VisitorsGivenUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.visitors_count);
          return pData;
        });
        fileName = `Top10Visitors_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Visitors Given Count`;
      } else if (reportType === "top_10_121_members") {
        // Define table headers and data
        headers.push("121s Count");
        pdfData = data.top10121sGivenUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.one2one_count);
          return pData;
        });
        fileName = `Top10121s_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by 121s Given Count`;
      } else if (reportType === "top_10_inductions_members") {
        // Define table headers and data
        headers.push("Inductions Count");
        pdfData = data.top10InductionsGivenUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.inductions_count);
          return pData;
        });
        fileName = `Top10Inductions_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Inductions Given Count`;
      }

      //pdf title starts
      const textWidth =
        (doc.getStringUnitWidth(pdfTitle) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      const textOffset = (doc.internal.pageSize.width - textWidth) / 2;
      doc.text(pdfTitle, textOffset, 10); // Centered title at the top
      //pdf title ends

      // Add the table to the document
      doc.autoTable({
        head: [headers],
        body: pdfData,
        margin: { top: 20, right: 20, bottom: 20, left: 20 }, // Adjust margins
        startY: 20, // Start position of the table from top
        headerStyles: { fillColor: [66, 2, 3], textColor: [255, 255, 255] }, // Change header color
        styles: { lineWidth: 0.1 }, // Set border width for table cells
      });
      // Save the PDF
      doc.save(fileName);
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
      toast.error(error.message);
    } finally {
      setPdfLoading(false);
    }
  };

  //month wise chart data - business achieved
  const [chartDataSet, setChartDataSet] = useState([]);
  const valueFormatter = (value) =>
    `₹${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(value)}`;
  const chartSetting = {
    series: [
      {
        dataKey: "amount",
        label: "Business",
        valueFormatter,
        color: "#420203",
      },
    ],
    height: 200,
    sx: {
      [`& .${axisClasses.directionY}`]: {
        transform: "translateX(-10px)",
      },
    },
  };
  //end

  //month wise chart data - 121s, rfls, visitors
  const [chartDataSet1, setChartDataSet1] = useState([]);

  const chartSetting1 = {
    yAxis: [
      {
        label: "",
        width: 60,
      },
    ],
    height: 200,
  };
  //end

  //month wise chart data - incomes / expenses
  const [chartDataSet2, setChartDataSet2] = useState([]);
  const amountFormatter = (value) =>
    `₹${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(value)}`;
  const chartSetting2 = {
    series: [
      {
        dataKey: "income",
        label: "Income",
        valueFormatter: amountFormatter,
        color: "#149614",
      },
      {
        dataKey: "expense",
        label: "Expense",
        valueFormatter: amountFormatter,
        color: "#FF3E1D",
      },
    ],
    yAxis: [
      {
        label: "",
        width: 60,
      },
    ],
    height: 200,
  };
  //end

  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    refFlatpickr.current.flatpickr.setDate([]);
    setFilter({
      ...filter,
      from_date: "",
      to_date: "",
    });
  };

  useEffect(() => {
    setOvalLoading(true);
    setLoading(true);
    axios
      .get(DASHBOARD, {
        params: {
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data);
          setChartDataSet(response.data.data.monthWiseBusinessList);
          setChartDataSet1(response.data.data.monthWise121RFlVisitorList);
          setChartDataSet2(response.data.data.monthWiseIncomesExpensesList);
        }
      })
      .finally(() => {
        setOvalLoading(false);
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [filter]);

  const handleCalendarClick = () => {
    if (refFlatpickr.current) {
      refFlatpickr.current.flatpickr.open();
    }
  };

  return (
    <div className="content-wrapper">
      <div className="flex-grow-1">
        <div className="container-fluid dp-wrapper px-0">
          <div className="row mb-3 align-items-end justify-content-end">
            <div className="col-md-12">
              <div className="filter_wrapper">
                {hasRole([1]) && (
                  <div className="mb-3 col-md-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="country_id"
                      isClearable
                      options={countryOptions}
                      placeholder="All Countries"
                      onChange={(selected) => {
                        handleStateClear();
                        setFilter({
                          ...filter,
                          country_id: selected?.value,
                          state_id: null,
                          region_id: null,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                )}

                {hasRole([1, 6]) && (
                  <div className="mb-3 col-md-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectStateRef}
                      name="state_id"
                      isClearable
                      options={stateOptions}
                      placeholder="All States"
                      onChange={(selected) => {
                        handleRegionClear();
                        setFilter({
                          ...filter,
                          state_id: selected?.value,
                          region_id: null,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                )}

                {hasRole([1, 6, 7]) && (
                  <div className="mb-3 col-md-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectRegionRef}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      placeholder="All Regions"
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({
                          ...filter,
                          region_id: selected?.value,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                )}

                {hasRole([1, 6, 7, 2]) && (
                  <div className="mb-3 col-md-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      placeholder="All Chapters"
                      onChange={(selected) =>
                        setFilter({ ...filter, chapter_id: selected?.value })
                      }
                    />
                  </div>
                )}

                <div className="mb-3 col-md-2">
                  <div className="dash_dp datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickr}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              setFilter({
                                ...filter,
                                from_date: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                to_date: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearBtn(false);
                            }
                          },
                        }}
                        placeholder="Date Range"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* dashboard counts */}

        <div className="row mb-4">
          <div className="col-xl-12">
            <div className="card crm-widget mb-3">
              <div className="card-body p-0">
                <div className="row row-cols-xxl-6 row-cols-md-3 row-cols-1 g-0">
                  {hasRole([1]) && hasPermission("countries-list") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/countries"}>
                        <div className="py-4 px-3 hover-link">
                          <h5 className="fs-15">Countries</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Country} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                <span className="counter-value">
                                  {ovalLoading ? (
                                    <OvalLoader color="#420203" />
                                  ) : (
                                    data.countryCount || 0
                                  )}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasRole([1, 6]) && hasPermission("states-list") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/states"}>
                        <div className="py-4 px-3 hover-link">
                          <h5 className="fs-15">States</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={State} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                <span className="counter-value">
                                  {ovalLoading ? (
                                    <OvalLoader color="#420203" />
                                  ) : (
                                    data.stateCount || 0
                                  )}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasRole([1, 6, 7]) && hasPermission("regions-list") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/regions"}>
                        <div className="py-4 px-3 hover-link">
                          <h5 className="fs-15">Regions</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Region} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                <span className="counter-value">
                                  {ovalLoading ? (
                                    <OvalLoader color="#420203" />
                                  ) : (
                                    data.regionCount
                                  )}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasRole([1, 6, 7, 2]) && hasPermission("chapters-list") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/chapters"}>
                        <div className="mt-3 mt-md-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">Chapters</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Glasschap} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#420203" />
                                ) : (
                                  data.chapterCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasPermission("members-list") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/users"}>
                        <div className="mt-3 mt-md-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">Members</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Glassusers} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#7A4100" />
                                ) : (
                                  data.usersCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasRole([1]) && hasPermission("country-admins-list") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/country-admin-users"}>
                        <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">Country Admins</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Admin} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#420203" />
                                ) : (
                                  data.countryAdminUsersCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasRole([1, 6]) && hasPermission("state-admins-list") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/state-admin-users"}>
                        <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">State Admins</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Admin} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#420203" />
                                ) : (
                                  data.stateAdminUsersCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasRole([1, 6, 7]) &&
                    hasPermission("region-admins-list") && (
                      <div className="col border-right border-bottom">
                        <Link to={"/region-admin-users"}>
                          <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                            <h5 className="fs-15">Region Admins</h5>
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0">
                                <img src={Admin} alt="icon" />
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <h2 className="mb-0 cfs-22">
                                  {ovalLoading ? (
                                    <OvalLoader color="#420203" />
                                  ) : (
                                    data.regionAdminUsersCount
                                  )}
                                </h2>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    )}

                  {hasRole([1, 6, 7, 2]) &&
                    hasPermission("chapter-admins-list") && (
                      <div className="col border-right border-bottom">
                        <Link to={"/chapter-admin-users"}>
                          <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                            <h5 className="fs-15">Chapter Admins</h5>
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0">
                                <img src={Admin} alt="icon" />
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <h2 className="mb-0 cfs-22">
                                  {ovalLoading ? (
                                    <OvalLoader color="#420203" />
                                  ) : (
                                    data.chapterAdminUsersCount
                                  )}
                                </h2>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    )}

                  {hasPermission("dashboard-121s-data-view") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/one-to-one"}>
                        <div className="py-4 px-3 hover-link">
                          <h5 className="fs-15">121s</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={One2one} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                <span className="counter-value">
                                  {ovalLoading ? (
                                    <OvalLoader color="#e3410f" />
                                  ) : (
                                    data.one2oneCount
                                  )}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasPermission("dashboard-rfls-data-view") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/referrals"}>
                        <div className="mt-3 mt-md-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">RFLs</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Referals} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#CC337F" />
                                ) : (
                                  data.referralsCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasPermission("dashboard-tyns-data-view") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/tyfcbs"}>
                        <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">TYNs</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Contribution} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#e3410f" />
                                ) : (
                                  data.tynsCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasPermission("dashboard-visitors-data-view") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/visitors/general"}>
                        <div className="mt-3 mt-md-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">Visitors</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Glassusers} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#003768" />
                                ) : (
                                  data.generalVisitorsCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasPermission("dashboard-visitors-data-view") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/visitors/chief-guest"}>
                        <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">Chief Guest</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Guest} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#7A4100" />
                                ) : (
                                  data.chiefGuestCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasPermission("dashboard-visitors-data-view") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/visitors/power-date"}>
                        <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">Power Date</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Powerdate} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#003768" />
                                ) : (
                                  data.powerDateCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasPermission("dashboard-visitors-data-view") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/visitors/inductions"}>
                        <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">Inductions</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Inductions} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#003768" />
                                ) : (
                                  data.inductionsCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {hasPermission("events-list") && (
                    <div className="col border-right border-bottom">
                      <Link to={"/events"}>
                        <div className="mt-3 mt-lg-0 py-4 px-3 hover-link">
                          <h5 className="fs-15">Events</h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img src={Events} alt="icon" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0 cfs-22">
                                {ovalLoading ? (
                                  <OvalLoader color="#420203" />
                                ) : (
                                  data.eventsCount
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {hasPermission("dashboard-tyns-data-view") && (
          <div className="row mb-4">
            <div className="col-lg-12 d-flex align-items-stretch">
              <div
                className="card w-100 overflow-hidden shadow-none overall-card"
                style={{ backgroundColor: "#f6e9ea" }}
              >
                <div
                  className="card-body position-relative"
                  style={{
                    "--swiper-navigation-size": "30px",
                    "--swiper-navigation-color": "#420203",
                  }}
                >
                  <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    <SwiperSlide>
                      <div className="row d-flex align-items-center">
                        <div className="col-sm-4 p-40">
                          <div className="overall-wrapper">
                            <div className="d-flex align-items-center mb-7">
                              <div className="rounded-circle overflow-hidden me-2">
                                <img
                                  src={user1}
                                  alt="img"
                                  width="40"
                                  height="40"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center">
                              <div className="border-end pe-4 border-muted border-opacity-10">
                                <h5 className="fw-semibold mb-0 fs-5 d-flex align-items-center">
                                  Overall Business Achieved
                                </h5>
                                <h3 className="mb-1 fw-semibold fs-8 d-flex align-content-center">
                                  {ovalLoading ? (
                                    <OvalLoader color="#CC337F" />
                                  ) : (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip className="tyntooltip">
                                          {data.overallTynsAmountText || ""}
                                        </Tooltip>
                                      }
                                    >
                                      <span style={{ cursor: "pointer" }}>
                                        {data.overallTynsAmount}
                                      </span>
                                    </OverlayTrigger>
                                  )}

                                  <i className="ti ti-arrow-up-right fs-5 lh-base text-success"></i>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-8 pl-30">
                          <div className="d-flex h-100 align-items-center justify-content-center">
                            {ovalLoading ? (
                              <OvalLoader color="#CC337F" />
                            ) : (
                              <BarChart
                                // borderRadius={4}
                                dataset={chartDataSet}
                                // grid={{ horizontal: true }}
                                xAxis={[
                                  {
                                    scaleType: "band",
                                    dataKey: "month",
                                    tickPlacement: "middle",
                                    tickLabelPlacement: "middle",
                                  },
                                ]}
                                {...chartSetting}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="row d-flex align-items-center">
                        <div className="col-sm-12 pl-30">
                          <div className="d-flex h-100 align-items-center justify-content-center">
                            {ovalLoading ? (
                              <OvalLoader color="#CC337F" />
                            ) : (
                              <BarChart
                                dataset={chartDataSet1}
                                xAxis={[
                                  { dataKey: "month", scaleType: "band" },
                                ]}
                                series={[
                                  {
                                    dataKey: "tyfcb",
                                    label: "TYNs",
                                    color: "#FF9800",
                                  },
                                  {
                                    dataKey: "one_to_one",
                                    label: "121s",
                                    color: "#1976d2",
                                  },
                                  {
                                    dataKey: "referral",
                                    label: "RFLs",
                                    color: "#388e3c",
                                  },
                                  {
                                    dataKey: "visitor",
                                    label: "Visitors",
                                    color: "#f57c00",
                                  },
                                ]}
                                {...chartSetting1}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="row d-flex align-items-center">
                        <div className="col-sm-12 pl-30">
                          <div className="d-flex h-100 align-items-center justify-content-center">
                            {ovalLoading ? (
                              <OvalLoader color="#CC337F" />
                            ) : (
                              <BarChart
                                dataset={chartDataSet2}
                                xAxis={[
                                  { dataKey: "month", scaleType: "band" },
                                ]}
                                series={[
                                  {
                                    dataKey: "income",
                                    label: "Income",
                                    color: "#149614",
                                  },
                                  {
                                    dataKey: "expense",
                                    label: "Expense",
                                    color: "#FF3E1D",
                                  },
                                ]}
                                {...chartSetting2}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        )}

        {(hasPermission("dashboard-tyns-data-view") ||
          hasPermission("dashboard-121s-data-view") ||
          hasPermission("dashboard-rfls-data-view") ||
          hasPermission("dashboard-visitors-data-view")) && (
          <div className="row">
            <div className="col-lg-12">
              <div className="card mb-3 custom-card">
                <div className="card-header border-bottom">
                  <h5>
                    This Week Top Achievers ({data.week_start_date} -{" "}
                    {data.week_end_date})
                  </h5>

                  {/* <Select
                  name="dateFilterId"
                  isClearable
                  options={dateFilterOptions}
                  placeholder="Overall"
                  onChange={(selected) => {
                    // setFilter({
                    //   ...filter,
                    //   dateFilterId: selected?.value,
                    // });
                  }}
                /> */}
                </div>
                <div className="card-body">
                  <div className="row">
                    {hasPermission("dashboard-tyns-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Biz Given ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekOverallTyfcb
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={Smile} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#420203" />
                            ) : data.thisWeekTop3AchieversList.tyfcbsList
                                ?.length > 0 ? (
                              data.thisWeekTop3AchieversList.tyfcbsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.from_user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.tyfcb_amount}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {hasPermission("dashboard-121s-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                121s ({" "}
                                {data.thisWeekTop3AchieversList?.thisWeek121s} )
                              </h3>
                            </div>
                            <div>
                              <img src={OnetoOneWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#420203" />
                            ) : data.thisWeekTop3AchieversList.onetooneList
                                ?.length > 0 ? (
                              data.thisWeekTop3AchieversList.onetooneList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.from_user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.from_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.from_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.from_user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.one2one_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-rfls-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                {" "}
                                RFLs ({" "}
                                {data.thisWeekTop3AchieversList?.thisWeekRfls} )
                              </h3>
                            </div>
                            <div>
                              <img src={RflWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#420203" />
                            ) : data.thisWeekTop3AchieversList.referralsList
                                ?.length > 0 ? (
                              data.thisWeekTop3AchieversList.referralsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.from_user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.from_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.from_user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.referrals_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Visitors (
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekVisitors
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={VisitorsWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#420203" />
                            ) : data.thisWeekTop3AchieversList
                                .generalVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.generalVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Chief Guest ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekChiefGuests
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={chiefGuestWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#420203" />
                            ) : data.thisWeekTop3AchieversList
                                .cheifGuestVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.cheifGuestVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Power Date ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekPowerDates
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={calendarWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#420203" />
                            ) : data.thisWeekTop3AchieversList
                                .powerDateVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.powerDateVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Inductions ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekInductions
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={calendarWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#420203" />
                            ) : data.thisWeekTop3AchieversList
                                .inductionsVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.inductionsVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row dash-table">
        {hasPermission("dashboard-meeting-fees-pending-list-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Weekly Meeting Fee Payment Pending List</h5>
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                      <th>Name</th>
                      <th>Pending Weeks</th>
                      <th>Pending Fees</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="8" />
                    ) : data.weeklyFeesPendingList?.length > 0 ? (
                      data.weeklyFeesPendingList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.pending_weeks}</td>
                          <td>{users?.pending_fees}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="8" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {hasPermission("dashboard-weekly-meeting-not-attended-list-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Weekly Attendance Absentees List</h5>
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                      <th>Name</th>
                      <th>Absent Meetings</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.weeklyMeetingPendingList?.length > 0 ? (
                      data.weeklyMeetingPendingList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.pending_weeks}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row dash-table">
        {hasPermission("dashboard-points-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 Performing Members</h5>
                {hasPermission("dashboard-points-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#420203",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_points_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                      <th>Name</th>
                      <th>Points</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10PointsUsersList?.length > 0 ? (
                      data.top10PointsUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.points}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {hasPermission("dashboard-tyns-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 Business Given Members</h5>
                {hasPermission("dashboard-tyns-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#420203",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_business_given_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="text-nowrap table-responsive">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                      <th>Name</th>
                      <th>Business Value</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10BusinessUsersList?.length > 0 ? (
                      data.top10BusinessUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.business_value}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row dash-table">
        {hasPermission("dashboard-rfls-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 RFLs Given Members</h5>
                {hasPermission("dashboard-rfls-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#420203",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_referral_given_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                      <th>Name</th>
                      <th>RFLs Count</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10ReferralsGivenUsersList?.length > 0 ? (
                      data.top10ReferralsGivenUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.referrals_count}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {hasPermission("dashboard-visitors-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 Visitors Given Members</h5>
                {hasPermission("dashboard-visitors-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#420203",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_visitors_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                      <th>Name</th>
                      <th>Visitors Count</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10VisitorsGivenUsersList?.length > 0 ? (
                      data.top10VisitorsGivenUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.visitors_count}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {hasPermission("dashboard-121s-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 121s By Members</h5>
                {hasPermission("dashboard-121s-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#420203",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_121_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                      <th>Name</th>
                      <th>121s Count</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10121sGivenUsersList?.length > 0 ? (
                      data.top10121sGivenUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.one2one_count}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {hasPermission("dashboard-visitors-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 Inductees Members</h5>
                {hasPermission("dashboard-visitors-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#420203",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_inductions_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                      <th>Name</th>
                      <th>Inductions Count</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10InductionsGivenUsersList?.length > 0 ? (
                      data.top10InductionsGivenUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.inductions_count}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="content-backdrop fade"></div>
    </div>
  );
};

export default Dashboard;
